import "./SignupCM.css";
import { Link } from "react-router-dom";
import { missingPopup } from "../../../../helpers/dataHelper/missingData";
import { toastify } from "../../../../helpers/toast/toastify";
import { useState } from "react";
import eyeBlockIcon from "../../../../assets/images/eye-block.svg";
import eyeIcon from "../../../../assets/images/eye.svg";
import FloatingTextFiled from "../../../sharedPages/CommonComponents/FloatingTextFiled/FloatingTextFiled";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import validator from "validator";
import { setLoading } from "../../../../redux/loading/loadingSlice";
import { setUserEmail, storeUser } from "../../../../redux/users/usersSlice";
import ProfileIcon from "../../../../assets/images/Profile.svg";
import { useDispatch } from "react-redux";
import { globalCommunity } from "../../../../store/globalstore";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";

const PASSWORD_RULES = {
  DIGIT: /[0-9]/,
  MIN_LENGTH: 8,
  SPECIAL: /[!@#$%^&*()_+{}[\]:;<>,.?~-]/,
  UPPERCASE: /[A-Z]/,
};

const SignupCM = () => {
  const [communityFromStore] = useAtom(globalCommunity);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [data, setData] = useState({
    email: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");

  const api = useApi();

  const handlePasswordChange = (value) => {
    const newPassword = value.trim();

    setData((prevState) => ({ ...prevState, password: newPassword }));

    const validationRules = [
      { message: "", test: (pwd) => !pwd },
      {
        message: "Password must be at least 8 characters long",
        test: (pwd) => !validator.isLength(pwd, { min: 8 }),
      },
      {
        message: "Password must contain at least one digit",
        test: (pwd) => !PASSWORD_RULES.DIGIT.test(pwd),
      },
      {
        message: "Password must contain at least one special character",
        test: (pwd) => !PASSWORD_RULES.SPECIAL.test(pwd),
      },
      {
        message: "Password must contain at least one uppercase letter",
        test: (pwd) => !PASSWORD_RULES.UPPERCASE.test(pwd),
      },
    ];

    setValidationMessage(
      validationRules.find((rule) => rule.test(newPassword))?.message || ""
    );
  };

  const handleSignup = async () => {
    setIsLoading(true);

    try {
      if (!communityFromStore) return toastify("Community is missing");

      if (!data.email) return missingPopup("Email");
      if (!data.password) return missingPopup("Password");

      if (!/\S+@\S+\.\S+/.test(data?.email))
        return toastify("Please enter a valid email address");
      if (validationMessage) return toastify(validationMessage);

      dispatch(setLoading(true));

      const response = await api("post", "newonBoard/signupMember", {
        ...data,
        community: communityFromStore,
      });

      if (response?.status) {
        setTimeout(() => {
          dispatch(setLoading(false));
          dispatch(setUserEmail(data.email))
          // dispatch(storeUser(response?.data));
          // localStorage.setItem("token", response?.data?.token);
          localStorage.removeItem("fromRoute", "");
          navigate("/login/newVerifyEmail", { replace: true });
        }, 1500);
      } else {
        setTimeout(() => {
          dispatch(setLoading(false));
          toastify(response?.message);
        }, 1500);
      }
    } catch (error) {
      console.error("🚀 -> handleSignup -> error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLoginClick = () => {
  localStorage.setItem("fromRoute", "community"); // store whatever you want
  navigate("/login");
};

  return (
    <div className="onboardinLayout cmSide">
      <div className="onboardingCard">
        <div className="onboardingCardTopBox">
        {communityFromStore?.logo ? (
                <img 
                  src={communityFromStore.logo} 
                  alt={`${communityFromStore?.disPlayName} logo`}
                  className="communityLogo"
                />
              ):(
                
                  <img src={ProfileIcon} alt="community logo" className="communityLogo" />
                
              )}
          <p className="businessName">
            {communityFromStore?.disPlayName?.toUpperCase()}
          </p>
        </div>
        <div className="onboardingCardContentBox cmSide">
          <div className="headingBox p-0 mb50px">
            <h2 className="title mb8px">Create an account</h2>
            <p className="subText ">Submit email and a strong password</p>
          </div>
          <div className="inputBox">
            <FloatingTextFiled
              className={`onboardingInput loginSignUpInput ${data.email ? "filled" : ""}`}
              forLabel="Email"
              label="Email"
              onChange={(e) =>
                setData((prevState) => ({
                  ...prevState,
                  email: e.target.value,
                }))
              }
              placeholder="Email"
              type="email"
              value={data.email}
            />
          </div>
          <div className="inputBox password">
            <FloatingTextFiled
              className={`onboardingInput loginSignUpInput ${data.password ? "filled" : ""}`}
              forLabel="Password"
              label="Password"
              onChange={(e) => handlePasswordChange(e.target.value)}
              placeholder="Password"
              type={showPassword ? "text" : "password"}
              value={data.password}
            />
            <button
              className={`eyebtn ${showPassword && "view"}`}
              onClick={() => setShowPassword((prev) => !prev)}
              type="button"
            >
              <img alt="" src={showPassword ? eyeIcon : eyeBlockIcon} />
            </button>
          </div>

          <BubbleSvgButton
            onClick={handleSignup}
            text={`Next`}
            type="button"
            variant="black"
            disabled={isLoading}
            containerStyling={{
              justifyContent: "center",
            }}
          />

          <p className="loginBottom" style={{marginTop: "20px"}}>
            Already have an account? <Link to="/login">Log In</Link>
          </p>
        

        </div>
        {/* <div className="paginationDots">
          <button className="dot active"></button>
          <button className="dot"></button>
          <button className="dot"></button>
          <button className="dot"></button>
          <button className="dot"></button>
          <button className="dot"></button>
          <button className="dot"></button>
        </div> */}
      </div>
    </div>
  );
};

export default SignupCM;
